<template>
    <div class="invoice-design-page">
        <div v-if="loading && !designLoaded" class="invoice-design-initial-loading" v-loading="true"></div>
        <el-alert v-else-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
        <div v-else-if="designLoaded" class="invoice-design-layout">
        <div class="leftScrollbar invoice-design-sidebar">
            <div class="invoice-design-save-bar">
                <el-button @click.native.prevent="saveDesign" type="success"
                           :disabled="!designLoaded || loading || buttonDisabledStatus || pageHaveChange !== 1">{{$t('common.save')}}</el-button>
            </div>
            <el-scrollbar class="invoice-design-scroll">
            <el-collapse v-model="activeNames" accordion @change="handleChange" style="border-width: 2px;height: 100%;border-top-style: none">

                <el-collapse-item :title="$t('invoiceDesign.template')" name="1">

                    <div style="display: flex;flex-wrap:wrap;align-content: space-between;">

                        <div style="flex-basis: 100%;display: flex; justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Classic',0)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[0][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/classic.png" alt="">

                            <img v-on:click="selectPdfStyle('Impact',1)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[1][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Impact.svg" alt="">
                        </div>
                        <div style="flex-basis: 100%;display: flex;justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Minimal',2)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[2][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Minimal.svg" alt="">

                            <img v-on:click="selectPdfStyle('Elegance',3)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[3][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Elegance.svg" alt="">
                        </div>
                        <div style="flex-basis: 100%;display: flex;justify-content: space-between;margin-left: 10%;margin-right: 10%;margin-bottom: 20px">
                            <img v-on:click="selectPdfStyle('Modern',4)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[4][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Modern.svg" alt="">

                            <img v-on:click="selectPdfStyle('Creative',5)"
                                 v-bind:style="{'border-style':'dashed','border-color':predefinePdfStyleList[5][1],'border-width':'1px','cursor':'pointer'}"
                                 width="40%" src="@/static/pdf_icon/Creative.svg" alt="">
                        </div>
                    </div>

                </el-collapse-item>

                <el-collapse-item :title="$t('invoiceDesign.color')" name="2">
                    <div class="collection" style="display: flex;flex-wrap:wrap;align-items:center;margin-left: 6%;margin-top: 20px">
                        <el-card shadow="hover"
                                 v-for="color in predefineColors"
                                 :key="color"
                                 @click.native="selected(color)"
                                 v-bind:style="{'background-color':color,'width':'40px','height':'40px','margin-right':'4%','margin-bottom':'35px','cursor':'pointer'}">
                            <label v-if="chooseColor == color"><i class="el-icon-circle-check" style="color: white;font-size: 18px;"></i></label>
                        </el-card>
                    </div>
                </el-collapse-item>

                <el-collapse-item :title="$t('invoiceDesign.labels')" name="3">

                    <el-form class="aaaa" label-position="top" label-width="80px">
                        <el-form-item :label="$t('invoiceDesign.labelInvoice')">
                            <el-input v-model="label.invoiceLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelEstimate')">
                            <el-input v-model="label.estimateLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelPurchaseOrder')">
                            <el-input v-model="label.purchaseOrderLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelCreditMemo')">
                            <el-input v-model="label.creditMemoLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelReceipt')">
                            <el-input v-model="label.receiptLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelTermsFormat')">
                            <el-input v-model="label.termsFormatLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelBillTo')">
                            <el-input v-model="label.billToLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelFor')">
                            <el-input v-model="label.forLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelDate')">
                            <el-input v-model="label.dateLabel"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.labelInvoiceNo')">
                            <el-input v-model="label.invoiceNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelEstimateNo')">
                            <el-input v-model="label.estimateNoLabel"></el-input>
                        </el-form-item>


                        <el-form-item :label="$t('invoiceDesign.labelPoNo')">
                            <el-input v-model="label.purchaseOrderNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelCreditMemoNo')">
                            <el-input v-model="label.creditMemoNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDueDate')">
                            <el-input v-model="label.dueDateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTerms')">
                            <el-input v-model="label.termsLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelAmount')">
                            <el-input v-model="label.amountLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelCode')">
                            <el-input v-model="label.codeLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDescription')">
                            <el-input v-model="label.descriptionLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelQuantity')">
                            <el-input v-model="label.quantityLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelRate')">
                            <el-input v-model="label.rateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTax')">
                            <el-input v-model="label.taxLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelSubtotal')">
                            <el-input v-model="label.subtotalLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelBalanceDue')">
                            <el-input v-model="label.balanceDueLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelDiscount')">
                            <el-input v-model="label.discountLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelNonTaxableItem')">
                            <el-input v-model="label.nonTaxableItemLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelPaid')">
                            <el-input v-model="label.paidLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipping')">
                            <el-input v-model="label.shippingLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTotal')">
                            <el-input v-model="label.totalLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelIncludes')">
                            <el-input v-model="label.includesLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTotalAmountPaid')">
                            <el-input v-model="label.totalAmountPaidLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipDate')">
                            <el-input v-model="label.shipDateLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipTo')">
                            <el-input v-model="label.shipToLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelShipVia')">
                            <el-input v-model="label.shipViaLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelTrackingNo')">
                            <el-input v-model="label.trackingNoLabel"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('invoiceDesign.labelFob')">
                            <el-input v-model="label.fobLabel"></el-input>
                        </el-form-item>

                        <!--<el-form-item label="F.O.B">
                            <el-input v-model="label.paymentInstructionsLabel"></el-input>
                        </el-form-item>-->

                    </el-form>

                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.prefix')" name="4">
                    <el-form label-position="top" label-width="80px" class="aaaa">
                        <el-form-item :label="$t('invoiceDesign.prefixInvoice')">
                            <el-input v-model="companyInfo.invoiceNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixEstimate')">
                            <el-input v-model="companyInfo.estimateNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixPurchaseOrder')">
                            <el-input v-model="companyInfo.purchaseOrderNumbering"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.prefixCreditMemo')">
                            <el-input v-model="companyInfo.creditMemoNumbering"></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.nextNumber')" name="6">
                    <el-form label-position="top" label-width="80px" class="aaaa">
                        <div class="next-number-title">{{$t('invoiceDesign.numberingBeginsAt')}}</div>
                        <el-form-item :label="$t('invoiceDesign.nextNumberInvoice')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewInvoiceNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberEstimate')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewEstimateNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberPurchaseOrder')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewPurchaseOrderNumber"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.nextNumberCreditMemo')">
                            <el-input inputmode="numeric" v-model="companyInfo.nextNewCreditMemoNumber"></el-input>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item :title="$t('invoiceDesign.options')" name="5">
                    <el-form class="invoice-design-options-form" label-position="left" label-width="230px" style="margin-left: 6%">
                        <el-form-item :label="$t('invoiceDesign.optionTerms')" prop="delivery">
                            <el-switch v-model="label.isShowPaymentTerms" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionDueDate')" prop="delivery">
                            <el-switch v-model="label.isShowDueDate" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionShippingAddress')" prop="delivery">
                            <el-switch v-model="label.isShowShippingField" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionProductCode')" prop="delivery">
                            <el-switch v-model="label.isShowProduceCode" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionQuantityAndRate')" prop="delivery">
                            <el-switch v-model="label.isShowQuantityAndRate" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionUnit')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowItemUnit" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionTax')" prop="delivery">
                            <el-switch v-model="label.isShowTaxColumn" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionAmount')" prop="delivery">
                            <el-switch v-model="label.isShowAmount" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionNonTaxableItemStar')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowNonTaxableItemStar" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionDiscount')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowItemDiscount" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionTaxBreakdown')" prop="delivery">
                            <el-switch v-model="label.isShowTaxBreakdown" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionPaymentHistory')" prop="delivery">
                            <el-switch v-model="label.isShowPaymentDetail" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionStamp')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowStamp" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                        <el-form-item :label="$t('invoiceDesign.optionPageNumber')" prop="delivery">
                            <el-switch v-model="companyInfo.isShowPDFPageNumber" :active-value=1 :inactive-value=0></el-switch>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            </el-scrollbar>
        </div>
        <div class="invoice-design-preview-scroll">

            <div class="rightScrollbar" style="margin-top: 20px;margin-bottom: 30px;padding-bottom: 1px;font-family: OpenSansblod;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);font-size: 12px">

                <div v-if="choosePdfStyle==='Classic'" style="display: flex;justify-content:space-between;">
                    <div style="margin-left: 3%">
                        <img v-if="logopath !== ''" :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logopath" alt="">

                        <div v-bind:style="{ 'color': chooseColor,'margin-top': '20px','font-size': '40px','font-weight':'bold'}">{{label.invoiceLabel}}</div>
                        <div v-if="companyInfo.hideBusinessName === 0"
                             :style="{'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{companyInfo.companyName}}</span></div>
                    </div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;align-self:flex-end">
                        <div>{{companyInfo.contactName}}</div>
                        <div>{{companyInfo.phone}}</div>
                        <div>{{companyInfo.companyEmail}}</div>
                        <div>{{companyInfo.businessNumber}}</div>
                        <div>{{label.taxRegNValue}}</div>
                        <div v-html="otherFieldShow"></div>
                        <div style="margin-top: 20px">{{companyInfo.addressOne}}</div>
                        <div>{{companyInfo.addressTwo}}</div>
                        <div>{{companyInfo.addressThree}}</div>
                    </div>
                </div>

                <div v-else-if="choosePdfStyle==='Impact' || choosePdfStyle==='Minimal'|| choosePdfStyle==='Modern'" v-bind:style="{'margin-bottom':'30px','background': modernBackgroundColor,'color': titlePartColor}">
                    <div style="margin-left: 3%">
                        <img v-if="logopath !== ''" :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logopath" alt="">
                        <div v-if="companyInfo.hideBusinessName === 0"
                             :style="{'margin-top': '20px', 'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{companyInfo.companyName}}</span></div>
                    </div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;display: flex;justify-content:space-between;align-items:flex-start ">
                        <div style="text-align: left;margin-left: 3%">
                            <div>{{companyInfo.contactName}}</div>
                            <div>{{companyInfo.phone}}</div>
                            <div>{{companyInfo.companyEmail}}</div>
                            <div>{{companyInfo.businessNumber}}</div>
                            <div v-html="otherFieldShow"></div>
                        </div>
                        <div style="text-align: left">
                            <div>{{label.taxRegNValue}}</div>
                            <div>{{companyInfo.addressOne}}</div>
                            <div>{{companyInfo.addressTwo}}</div>
                            <div>{{companyInfo.addressThree}}</div>
                        </div>
                        <div v-bind:style="{ 'color': invoiceLabelColor,'font-size': '40px','font-weight':'bold','align-self':'flex-end'}">{{label.invoiceLabel}}</div>
                    </div>
                </div>

                <div v-if="choosePdfStyle==='Elegance'">
                    <div style="text-align: center">
                        <img v-if="logopath !== ''" :style="{'padding-top': '20px', width: logoPreviewWidth + 'px'}" :src="logopath" alt="">
                        <div v-if="companyInfo.hideBusinessName === 0"
                             :style="{'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{companyInfo.companyName}}</span></div>

                    </div>

                    <div style="display: flex;justify-content:space-between;margin-left: 3%;margin-right: 3%;margin-bottom: 20px;margin-top: 5px">
                        <div>
                            <div>{{companyInfo.contactName}}</div>
                            <div>{{companyInfo.phone}}</div>
                            <div>{{companyInfo.companyEmail}}</div>
                            <div>{{companyInfo.businessNumber}}</div>
                            <div>{{label.taxRegNValue}}</div>
                            <div v-html="otherFieldShow"></div>
                        </div>
                        <div>
                            <div>{{companyInfo.addressOne}}</div>
                            <div>{{companyInfo.addressTwo}}</div>
                            <div>{{companyInfo.addressThree}}</div>
                        </div>
                        <div v-bind:style="{ 'color': chooseColor,'margin-top': '20px','font-size': '40px','font-weight':'bold','align-self':'flex-end'}">{{label.invoiceLabel}}</div>
                    </div>

                </div>


                <div v-else-if="choosePdfStyle==='Creative'" v-bind:style="{'margin-bottom':'30px','background': modernBackgroundColor}">
                    <div v-bind:style="{'padding-left':'3%', 'background': creativeInvoiceLabelBackgroundColor,'color': 'white','font-size': '90px','line-height': '75%','font-weight':'bold'}">{{label.invoiceLabel}}</div>
                    <div v-if="companyInfo.hideBusinessName === 0"
                         :style="{'margin-left': '3%', 'margin-top': '20px', 'font-weight': 'bold', 'font-size': businessNamePreviewFontSize + 'px'}"><span>{{companyInfo.companyName}}</span></div>

                    <div style="text-align: right;margin-right: 3%;padding-top: 20px;display: flex;justify-content:space-between;align-items:flex-start ">
                        <div style="text-align: left;margin-left: 3%">
                            <div>{{companyInfo.contactName}}</div>
                            <div>{{companyInfo.phone}}</div>
                            <div>{{companyInfo.companyEmail}}</div>
                            <div>{{companyInfo.businessNumber}}</div>
                            <div v-html="otherFieldShow"></div>
                        </div>
                        <div style="text-align: left">
                            <div>{{label.taxRegNValue}}</div>
                            <div>{{companyInfo.addressOne}}</div>
                            <div>{{companyInfo.addressTwo}}</div>
                            <div>{{companyInfo.addressThree}}</div>
                        </div>
                        <img v-if="logopath !== ''" :style="{width: logoPreviewWidth + 'px'}" :src="logopath" alt="">
                    </div>
                </div>


                <el-divider v-if="choosePdfStyle==='Classic' || choosePdfStyle==='Impact'"></el-divider>

                <div style="display: flex;margin-left: 3%;margin-right: 3%">
                    <div style="width: 10%;font-weight:bold;">{{label.billToLabel}}</div>
                    <div style="width: 40%">
                        <div>{{$t('invoiceDesign.previewName')}}</div>
                        <div>{{$t('invoiceDesign.previewAddress')}}</div>
                        <div>{{$t('invoiceDesign.previewCity')}}</div>
                        <div>{{$t('invoiceDesign.previewZip')}}</div>
                    </div>
                    <div style="width: 25%;text-align:right">
                        <div>{{label.invoiceNoLabel}}</div>
                        <div>{{label.dateLabel}}</div>
                        <div v-if="label.isShowPaymentTerms===1">{{label.termsLabel}}</div>
                        <div v-if="label.isShowDueDate===1">{{label.dueDateLabel}}</div>
                        <div v-html="jobdetailShowLeft"></div>
                    </div>
                    <div style="width: 25%;text-align:right;">
                        <div>{{companyInfo.invoiceNumbering}}99</div>
                        <div>{{$t('invoiceDesign.previewDate')}}</div>
                        <div v-if="label.isShowPaymentTerms===1">{{label.termsFormatLabel}}</div>
                        <div v-if="label.isShowDueDate===1">{{$t('classicPDF.previewDueDate')}}</div>
                        <div v-html="jobdetailShowRight"></div>
                    </div>
                </div>

                <div v-if="label.isShowShippingField===1">
                    <div style="display: flex;margin-left: 3%; margin-right:3%;margin-top: 30px">
                        <div style="width: 10%;font-weight:bold;">{{label.shipToLabel}}</div>
                        <div style="width: 40%">
                            <div>{{$t('invoiceDesign.previewShipName')}}</div>
                            <div>{{$t('invoiceDesign.previewAddress')}}</div>
                            <div>{{$t('invoiceDesign.previewCity')}}</div>
                            <div>{{$t('invoiceDesign.previewZip')}}</div>
                        </div>
                        <div style="width: 25%;text-align:right">
                            <div>{{label.shipDateLabel}}</div>
                            <div>{{label.trackingNoLabel}}</div>
                            <div>{{label.shipViaLabel}}</div>
                            <div>{{label.fobLabel}}</div>
                        </div>
                        <div style="width: 25%;text-align:right;">
                            <div>{{$t('invoiceDesign.previewShipDate')}}</div>
                            <div>12345</div>
                            <div>{{$t('invoiceDesign.previewShipVia')}}</div>
                            <div>123</div>
                        </div>
                    </div>
                </div>

                <el-table
                        :data="tableData"
                        :header-cell-style="{'font-size':'13px', 'background-color': itemTableAndBalanceDueBackgroundColor,'color':'black','padding-top':'7px','padding-bottom':'7px'}"
                        style="width: 100%;color: black;margin-top: 25px;font-size: 12px">
                    <el-table-column v-if="label.isShowProduceCode===1"
                                     prop="code"
                                     :label=label.codeLabel
                    >
                    </el-table-column>
                    <el-table-column
                            prop="description"
                            :label=label.descriptionLabel
                    >
                    </el-table-column>
                    <el-table-column v-if="label.isShowQuantityAndRate===1"
                                     prop="quantity"
                                     :label=label.quantityLabel>
                    </el-table-column>

                    <el-table-column
                            prop="rate" :formatter="moneyFormat" v-if="label.isShowQuantityAndRate===1"
                            :label=label.rateLabel>
                    </el-table-column>
                    <el-table-column
                            prop="unit" v-if="companyInfo.isShowItemUnit===1"
                            :label="$t('invoiceDesign.optionUnit')">
                    </el-table-column>
                    <el-table-column
                            prop="tax" v-if="label.isShowTaxColumn===1"
                            :label=label.taxLabel>
                    </el-table-column>
                    <el-table-column
                            prop="discount" v-if="companyInfo.isShowItemDiscount===1"
                            :label=label.discountLabel>
                    </el-table-column>
                    <el-table-column
                            prop="amount" :formatter="moneyFormat" v-if="label.isShowAmount===1" :label=label.amountLabel>
                    </el-table-column>
                </el-table>

                <div style="display: flex;margin-top: 30px;margin-left: 3%;margin-bottom: 50px">
                    <div style="width: 40%;font-size: 12px">
                        <div v-if="companyInfo.isShowNonTaxableItemStar===1">* {{label.nonTaxableItemLabel}}</div>
                        <div style="margin-top: 20px">{{$t('invoiceDesign.previewThanksMessage')}}</div>
                    </div>
                    <div style="width: 60%">
                        <div style="display: flex;text-align: right">
                            <div style="width: 60%">
                                <div>{{$t('invoiceDesign.previewSubtotal')}}</div>
                                <div>{{$t('invoiceDesign.previewVat')}}
                                    <span v-if="label.isShowTaxBreakdown===1">
                                        ({{xiaoshudianfenge1(2195.00000,label)}})
                                    </span>
                                </div>
                                <div>{{label.shippingLabel}}</div>
                                <div>{{label.totalLabel}}</div>
                                <div v-if="label.isShowPaymentDetail===1">{{$t('invoiceDesign.previewPayment1')}}</div>
                                <div v-if="label.isShowPaymentDetail===1">{{$t('invoiceDesign.previewPayment2')}}</div>
                                <div>{{label.paidLabel}}</div>
                                <div v-bind:style="{ 'background-color': itemTableAndBalanceDueBackgroundColor,'color':balanceDueTextColor,'margin-top': '10px','margin-bottom': '10px','font-weight':'bold','padding-top': '10px','padding-bottom': '10px'}">
                                    {{label.balanceDueLabel}}
                                </div>
                            </div>
                            <div style="width: 40%">
                                <div style="margin-right: 15%">
                                    <div>{{xiaoshudianfenge1(3994.10000,label)}}</div>
                                    <div>{{xiaoshudianfenge1(373.15000,label)}}</div>
                                    <div>{{xiaoshudianfenge1(8.00000,label)}}</div>
                                    <div>{{xiaoshudianfenge1(4375.25000,label)}}</div>
                                    <div v-if="label.isShowPaymentDetail===1">{{xiaoshudianfenge1(20.800000,label)}}</div>
                                    <div v-if="label.isShowPaymentDetail===1">{{xiaoshudianfenge1(14.800000,label)}}</div>
                                    <div>{{xiaoshudianfenge1(35.600000,label)}}</div>
                                </div>
                                <div v-bind:style="{ 'background-color': itemTableAndBalanceDueBackgroundColor,'color':balanceDueTextColor,'margin-top': '10px','margin-bottom': '10px','font-weight':'bold','padding-top': '10px','padding-bottom': '10px','padding-right': '15%'}">
                                    {{xiaoshudianfenge1(4339.65000,label)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>


</template>

<script>
    import {timest} from '@/utils/validate'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {
        replaceStoredCompany,
        replaceStoredSetting,
        syncCompanySelection
    } from '@/utils/company'
    import {getStoredImageDownloadUrl} from '@/utils/fileUpload'
    import {
        MAX_SAFE_NEXT_NUMBER,
        parseNextNumber
    } from '@/utils/invoiceDesignValidation'

    export default {
        computed: {
            logoPreviewWidth() {
                return [80, 100, 120][this.companyInfo.logoSize];
            },
            businessNamePreviewFontSize() {
                return [14, 24][this.companyInfo.businessNameSize];
            }
        },
        methods: {
            xiaoshudianfenge1: xiaoshudianfenge,
            designSnapshot() {
                const companyFields = [
                    'invoiceNumbering', 'estimateNumbering', 'purchaseOrderNumbering',
                    'creditMemoNumbering', 'nextNewInvoiceNumber', 'nextNewEstimateNumber',
                    'nextNewPurchaseOrderNumber', 'nextNewCreditMemoNumber', 'isShowPDFPageNumber',
                    'isShowStamp', 'isShowNonTaxableItemStar', 'isShowItemUnit', 'isShowItemDiscount'
                ];
                const settingFields = [
                    'invoiceLabel', 'estimateLabel', 'purchaseOrderLabel', 'creditMemoLabel',
                    'receiptLabel', 'termsFormatLabel', 'billToLabel', 'forLabel', 'dateLabel',
                    'invoiceNoLabel', 'estimateNoLabel', 'purchaseOrderNoLabel', 'creditMemoNoLabel',
                    'dueDateLabel', 'termsLabel', 'amountLabel', 'codeLabel', 'descriptionLabel',
                    'quantityLabel', 'rateLabel', 'taxLabel', 'subtotalLabel', 'balanceDueLabel',
                    'discountLabel', 'nonTaxableItemLabel', 'paidLabel', 'shippingLabel', 'totalLabel',
                    'includesLabel', 'totalAmountPaidLabel', 'shipDateLabel', 'shipToLabel',
                    'shipViaLabel', 'trackingNoLabel', 'fobLabel', 'isShowPaymentTerms',
                    'isShowDueDate', 'isShowShippingField', 'isShowProduceCode',
                    'isShowQuantityAndRate', 'isShowTaxColumn', 'isShowAmount',
                    'isShowTaxBreakdown', 'isShowPaymentDetail'
                ];
                const nextNumberFields = new Set([
                    'nextNewInvoiceNumber', 'nextNewEstimateNumber',
                    'nextNewPurchaseOrderNumber', 'nextNewCreditMemoNumber'
                ]);
                const company = {};
                const setting = {};
                companyFields.forEach(field => {
                    company[field] = nextNumberFields.has(field)
                        ? String(this.companyInfo[field]) : this.companyInfo[field];
                });
                settingFields.forEach(field => {
                    setting[field] = this.label[field];
                });
                return JSON.stringify({
                    company: company,
                    setting: setting,
                    pdfStyle: this.choosePdfStyle,
                    pdfColor: this.chooseColor
                });
            },
            updateDirtyState() {
                this.pageHaveChange = this.initialDesignSnapshot !== ''
                    && this.designSnapshot() !== this.initialDesignSnapshot ? 1 : 0;
            },
            handleChange() {
            },
            moneyFormat: function (row, column) {
                let timestamp = row[column.property];
                let formattedMoney = this.xiaoshudianfenge1(timestamp, this.label);
                if (column.property === 'amount'
                    && row.isNonTaxable === true
                    && this.companyInfo.isShowNonTaxableItemStar === 1) {
                    return formattedMoney + '*';
                }
                return formattedMoney;
            },
            validateDesignFields(normalizeNumbers) {
                let nextNumbers;
                try {
                    nextNumbers = [
                        parseNextNumber(this.companyInfo.nextNewInvoiceNumber),
                        parseNextNumber(this.companyInfo.nextNewEstimateNumber),
                        parseNextNumber(this.companyInfo.nextNewPurchaseOrderNumber),
                        parseNextNumber(this.companyInfo.nextNewCreditMemoNumber)
                    ];
                } catch {
                    throw new Error(this.$t('invoiceDesign.invalidNextNumber', {max: MAX_SAFE_NEXT_NUMBER}));
                }
                if (normalizeNumbers) {
                    this.companyInfo.nextNewInvoiceNumber = nextNumbers[0];
                    this.companyInfo.nextNewEstimateNumber = nextNumbers[1];
                    this.companyInfo.nextNewPurchaseOrderNumber = nextNumbers[2];
                    this.companyInfo.nextNewCreditMemoNumber = nextNumbers[3];
                }
            },
            queryUserSetting() {
                this.loading = true;
                this.designLoaded = false;
                this.loadError = '';
                this.buttonDisabledStatus = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    let selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }

                        that.label = selectedData.setting;
                        that.choosePdfStyle = that.label.pdfStyle;
                        that.companyInfo = selectedData.company;
                        that.chooseColor = selectedData.company.pdfColor;
                        if (that.chooseColor === '' || that.chooseColor === null) {
                            that.chooseColor = 'rgb(13,125,247)';
                        }
                        if (that.choosePdfStyle === 'Classic' || that.choosePdfStyle === 'Impact') {
                            that.itemTableAndBalanceDueBackgroundColor = that.chooseColor;
                        } else {
                            that.itemTableAndBalanceDueBackgroundColor = 'white';
                        }
                        if (that.choosePdfStyle === 'Modern') {
                            that.modernBackgroundColor = that.chooseColor;
                        } else {
                            that.modernBackgroundColor = "white";
                        }
                        if (that.choosePdfStyle === 'Modern') {
                            that.titlePartColor = "white";
                        } else {
                            that.titlePartColor = 'black';
                        }
                        if (that.choosePdfStyle === 'Classic') {
                            that.balanceDueTextColor = "black";
                        } else if (that.choosePdfStyle === 'Impact') {
                            that.balanceDueTextColor = "white";
                        } else {
                            that.balanceDueTextColor = that.chooseColor;
                        }

                        if (that.choosePdfStyle === 'Creative') {
                            that.creativeInvoiceLabelBackgroundColor = that.chooseColor;
                        } else {
                            that.creativeInvoiceLabelBackgroundColor = 'white';
                        }

                        if (that.choosePdfStyle === 'Modern') {
                            that.invoiceLabelColor = 'white';
                        } else {
                            that.invoiceLabelColor = that.chooseColor;
                        }

                        for (let i = 0; i < that.predefinePdfStyleList.length; i++) {
                            if (that.predefinePdfStyleList[i][0] === that.choosePdfStyle) {
                                that.predefinePdfStyleList[i][1] = "blue";
                            }
                        }

                        that.jobdetailShowLeft = '';
                        that.jobdetailShowRight = '';
                        that.otherFieldShow = '';
                        let jobDetails = that.companyInfo.jobDetails;
                        if (jobDetails != null && jobDetails != '') {
                            let splitSplit = jobDetails.split("&&");
                            for (let i = 0; i < splitSplit.length; i++) {

                                let split1 = splitSplit[i].split(":");
                                if (split1.length < 1) {
                                    continue;
                                }
                                that.jobdetailShowLeft += split1[0] + "</br>";
                                if (split1.length > 1) {
                                    that.jobdetailShowRight += split1[1] + "</br>";
                                }
                            }
                        }

                        let otherFields = that.companyInfo.otherFields;
                        if (otherFields != null && otherFields != '') {
                            let splitArray = otherFields.split("&&");
                            for (let i = 0; i < splitArray.length; i++) {

                                let split1 = splitArray[i].split(":");
                                if (split1.length > 1) {
                                    that.otherFieldShow += split1[1] + "</br>";
                                }
                            }
                        }

                        let companyLogoMap = response.data.companyLogoMap;
                        let companyLogo = companyLogoMap[selectedData.company.innerUUID];
                        if (companyLogo != null) {
                            this.logopath = getStoredImageDownloadUrl(this.$store.state.requestURL, companyLogo);
                            localStorage.setItem('logoPath', companyLogo.imagePath);
                        } else {
                            this.logopath = "";
                            localStorage.setItem('logoPath', "");
                        }
                    this.initialDesignSnapshot = this.designSnapshot();
                    this.pageHaveChange = 0;
                    this.designLoaded = true;
                    this.buttonDisabledStatus = false;
                    this.loading = false;

                    this.$watch('label', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('companyInfo', function () {
                        this.updateDirtyState();
                    }, {deep: true});
                    this.$watch('choosePdfStyle', this.updateDirtyState);
                    this.$watch('chooseColor', this.updateDirtyState);
                }).catch(() => {
                    this.loading = false;
                    this.loadError = this.$t('common.loadFailed');
                })
            },
            selected: function (color) {
                this.chooseColor = color;
                if (this.choosePdfStyle === 'Classic' || this.choosePdfStyle === 'Impact') {
                    this.itemTableAndBalanceDueBackgroundColor = this.chooseColor;
                } else {
                    this.itemTableAndBalanceDueBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.modernBackgroundColor = this.chooseColor;
                } else {
                    this.modernBackgroundColor = "white";
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.titlePartColor = "white";
                } else {
                    this.titlePartColor = 'black';
                }
                if (this.choosePdfStyle === 'Classic') {
                    this.balanceDueTextColor = "black";
                } else if (this.choosePdfStyle === 'Impact') {
                    this.balanceDueTextColor = "white";
                } else {
                    this.balanceDueTextColor = this.chooseColor;
                }

                if (this.choosePdfStyle === 'Creative') {
                    this.creativeInvoiceLabelBackgroundColor = this.chooseColor;
                } else {
                    this.creativeInvoiceLabelBackgroundColor = 'white';
                }

                if (this.choosePdfStyle === 'Modern') {
                    this.invoiceLabelColor = 'white';
                } else {
                    this.invoiceLabelColor = this.chooseColor;
                }
            },
            selectPdfStyle: function (pdfStyle, index) {
                this.choosePdfStyle = pdfStyle;
                for (let i = 0; i < 6; i++) {
                    this.predefinePdfStyleList[i][1] = "white";
                }
                this.predefinePdfStyleList[index][1] = "blue";

                if (this.choosePdfStyle === 'Classic' || this.choosePdfStyle === 'Impact') {
                    this.itemTableAndBalanceDueBackgroundColor = this.chooseColor;
                } else {
                    this.itemTableAndBalanceDueBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.modernBackgroundColor = this.chooseColor;
                } else {
                    this.modernBackgroundColor = "white";
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.titlePartColor = "white";
                } else {
                    this.titlePartColor = 'black';
                }
                if (this.choosePdfStyle === 'Classic') {
                    this.balanceDueTextColor = "black";
                } else if (this.choosePdfStyle === 'Impact') {
                    this.balanceDueTextColor = "white";
                } else {
                    this.balanceDueTextColor = this.chooseColor;
                }
                if (this.choosePdfStyle === 'Creative') {
                    this.creativeInvoiceLabelBackgroundColor = this.chooseColor;
                } else {
                    this.creativeInvoiceLabelBackgroundColor = 'white';
                }
                if (this.choosePdfStyle === 'Modern') {
                    this.invoiceLabelColor = 'white';
                } else {
                    this.invoiceLabelColor = this.chooseColor;
                }
            },

            saveDesign(flag, next) {
                if (!this.designLoaded || this.loading || this.buttonDisabledStatus || this.pageHaveChange !== 1) {
                    return;
                }
                try {
                    this.validateDesignFields(true);
                } catch (error) {
                    this.$message.error(error.message);
                    return;
                }
                let self = this;
                this.loading = true;

                let companyInfo = {
                    invoiceNumbering: this.companyInfo.invoiceNumbering,
                    estimateNumbering: this.companyInfo.estimateNumbering,
                    purchaseOrderNumbering: this.companyInfo.purchaseOrderNumbering,
                    creditMemoNumbering: this.companyInfo.creditMemoNumbering,
                    nextNewInvoiceNumber: this.companyInfo.nextNewInvoiceNumber,
                    nextNewEstimateNumber: this.companyInfo.nextNewEstimateNumber,
                    nextNewPurchaseOrderNumber: this.companyInfo.nextNewPurchaseOrderNumber,
                    nextNewCreditMemoNumber: this.companyInfo.nextNewCreditMemoNumber,
                    isShowPDFPageNumber: this.companyInfo.isShowPDFPageNumber,
                    isShowStamp: this.companyInfo.isShowStamp,
                    isShowNonTaxableItemStar: this.companyInfo.isShowNonTaxableItemStar,
                    isShowItemUnit: this.companyInfo.isShowItemUnit,
                    isShowItemDiscount: this.companyInfo.isShowItemDiscount,
                    pdfColor: this.chooseColor,

                    accessDate: timest(),
                    innerUUID: this.companyInfo.innerUUID,
                    companyUUID: this.companyInfo.innerUUID
                };

                let settingInfo = {
                    pdfStyle: this.choosePdfStyle,
                    invoiceLabel: this.label.invoiceLabel,
                    estimateLabel: this.label.estimateLabel,
                    purchaseOrderLabel: this.label.purchaseOrderLabel,
                    creditMemoLabel: this.label.creditMemoLabel,
                    termsFormatLabel: this.label.termsFormatLabel,
                    billToLabel: this.label.billToLabel,
                    forLabel: this.label.forLabel,
                    dateLabel: this.label.dateLabel,
                    invoiceNoLabel: this.label.invoiceNoLabel,
                    estimateNoLabel: this.label.estimateNoLabel,
                    creditMemoNoLabel: this.label.creditMemoNoLabel,
                    purchaseOrderNoLabel: this.label.purchaseOrderNoLabel,
                    dueDateLabel: this.label.dueDateLabel,
                    termsLabel: this.label.termsLabel,
                    amountLabel: this.label.amountLabel,
                    codeLabel: this.label.codeLabel,
                    descriptionLabel: this.label.descriptionLabel,
                    quantityLabel: this.label.quantityLabel,
                    rateLabel: this.label.rateLabel,
                    taxLabel: this.label.taxLabel,
                    balanceDueLabel: this.label.balanceDueLabel,
                    discountLabel: this.label.discountLabel,
                    nonTaxableItemLabel: this.label.nonTaxableItemLabel,
                    paidLabel: this.label.paidLabel,
                    shippingLabel: this.label.shippingLabel,
                    totalLabel: this.label.totalLabel,
                    includesLabel: this.label.includesLabel,
                    shipDateLabel: this.label.shipDateLabel,
                    shipToLabel: this.label.shipToLabel,
                    shipViaLabel: this.label.shipViaLabel,
                    trackingNoLabel: this.label.trackingNoLabel,
                    fobLabel: this.label.fobLabel,
                    isShowPaymentTerms: this.label.isShowPaymentTerms,
                    isShowDueDate: this.label.isShowDueDate,
                    isShowShippingField: this.label.isShowShippingField,
                    isShowProduceCode: this.label.isShowProduceCode,
                    isShowTaxColumn: this.label.isShowTaxColumn,
                    isShowAmount: this.label.isShowAmount,
                    isShowTaxBreakdown: this.label.isShowTaxBreakdown,
                    isShowPaymentDetail: this.label.isShowPaymentDetail,
                    isShowQuantityAndRate: this.label.isShowQuantityAndRate,
                    subtotalLabel: this.label.subtotalLabel,
                    receiptLabel: this.label.receiptLabel,
                    totalAmountPaidLabel: this.label.totalAmountPaidLabel,

                    innerUUID: this.label.innerUUID,
                    companyUUID: this.label.companyUUID,
                    accessDate: timest()
                }
                self.buttonDisabledStatus = true;
                this.$axios.post('update_setting_and_company', {
                    params: {"settingReq": settingInfo, "companyReq": companyInfo}
                }).then(response => {
                    this.loading = false;
                    self.buttonDisabledStatus = false;
                    if (response.data.errorCode === 0) {
                        this.initialDesignSnapshot = this.designSnapshot();
                        this.pageHaveChange = 0;

                        let tempUserSetting = JSON.parse(localStorage.getItem('userSetting'));
                        tempUserSetting.pdfStyle = this.choosePdfStyle;
                        tempUserSetting.invoiceLabel = this.label.invoiceLabel;
                        tempUserSetting.estimateLabel = this.label.estimateLabel;
                        tempUserSetting.purchaseOrderLabel = this.label.purchaseOrderLabel;
                        tempUserSetting.creditMemoLabel = this.label.creditMemoLabel;
                        tempUserSetting.termsFormatLabel = this.label.termsFormatLabel;
                        tempUserSetting.billToLabel = this.label.billToLabel;
                        tempUserSetting.forLabel = this.label.forLabel;
                        tempUserSetting.dateLabel = this.label.dateLabel;
                        tempUserSetting.invoiceNoLabel = this.label.invoiceNoLabel;
                        tempUserSetting.estimateNoLabel = this.label.estimateNoLabel;
                        tempUserSetting.creditMemoNoLabel = this.label.creditMemoNoLabel;
                        tempUserSetting.purchaseOrderNoLabel = this.label.purchaseOrderNoLabel;
                        tempUserSetting.dueDateLabel = this.label.dueDateLabel;
                        tempUserSetting.termsLabel = this.label.termsLabel;
                        tempUserSetting.amountLabel = this.label.amountLabel;
                        tempUserSetting.codeLabel = this.label.codeLabel;
                        tempUserSetting.descriptionLabel = this.label.descriptionLabel;
                        tempUserSetting.quantityLabel = this.label.quantityLabel;
                        tempUserSetting.rateLabel = this.label.rateLabel;
                        tempUserSetting.taxLabel = this.label.taxLabel;
                        tempUserSetting.balanceDueLabel = this.label.balanceDueLabel;
                        tempUserSetting.discountLabel = this.label.discountLabel;
                        tempUserSetting.nonTaxableItemLabel = this.label.nonTaxableItemLabel;
                        tempUserSetting.paidLabel = this.label.paidLabel;
                        tempUserSetting.shippingLabel = this.label.shippingLabel;
                        tempUserSetting.totalLabel = this.label.totalLabel;
                        tempUserSetting.includesLabel = this.label.includesLabel;
                        tempUserSetting.shipDateLabel = this.label.shipDateLabel;
                        tempUserSetting.shipToLabel = this.label.shipToLabel;
                        tempUserSetting.shipViaLabel = this.label.shipViaLabel;
                        tempUserSetting.trackingNoLabel = this.label.trackingNoLabel;
                        tempUserSetting.fobLabel = this.label.fobLabel;
                        tempUserSetting.isShowPaymentTerms = this.label.isShowPaymentTerms;
                        tempUserSetting.isShowDueDate = this.label.isShowDueDate;
                        tempUserSetting.isShowShippingField = this.label.isShowShippingField;
                        tempUserSetting.isShowProduceCode = this.label.isShowProduceCode;
                        tempUserSetting.isShowTaxColumn = this.label.isShowTaxColumn;
                        tempUserSetting.isShowAmount = this.label.isShowAmount;
                        tempUserSetting.isShowTaxBreakdown = this.label.isShowTaxBreakdown;
                        tempUserSetting.isShowPaymentDetail = this.label.isShowPaymentDetail;
                        tempUserSetting.isShowQuantityAndRate = this.label.isShowQuantityAndRate;
                        tempUserSetting.subtotalLabel = this.label.subtotalLabel;
                        tempUserSetting.receiptLabel = this.label.receiptLabel;
                        tempUserSetting.totalAmountPaidLabel = this.label.totalAmountPaidLabel;
                        replaceStoredSetting(tempUserSetting);

                        let tempCompany = JSON.parse(localStorage.getItem('userCompany'));
                        tempCompany.invoiceNumbering = this.companyInfo.invoiceNumbering;
                        tempCompany.estimateNumbering = this.companyInfo.estimateNumbering;
                        tempCompany.purchaseOrderNumbering = this.companyInfo.purchaseOrderNumbering;
                        tempCompany.creditMemoNumbering = this.companyInfo.creditMemoNumbering;
                        tempCompany.nextNewInvoiceNumber = this.companyInfo.nextNewInvoiceNumber;
                        tempCompany.nextNewEstimateNumber = this.companyInfo.nextNewEstimateNumber;
                        tempCompany.nextNewPurchaseOrderNumber = this.companyInfo.nextNewPurchaseOrderNumber;
                        tempCompany.nextNewCreditMemoNumber = this.companyInfo.nextNewCreditMemoNumber;
                        tempCompany.isShowPDFPageNumber = this.companyInfo.isShowPDFPageNumber;
                        tempCompany.isShowStamp = this.companyInfo.isShowStamp;
                        tempCompany.isShowNonTaxableItemStar = this.companyInfo.isShowNonTaxableItemStar;
                        tempCompany.isShowItemUnit = this.companyInfo.isShowItemUnit;
                        tempCompany.isShowItemDiscount = this.companyInfo.isShowItemDiscount;
                        tempCompany.pdfColor = this.chooseColor;
                        replaceStoredCompany(tempCompany);

                        this.$message.success({
                            message: this.$t('common.saveSuccess'),
                            center: true
                        });
                        if (flag === 100) {
                            next();
                        }
                    } else {
                        this.$message.error(this.$t('common.saveFailed'));
                    }
                }).catch(function () {
                    self.loading = false;
                    self.buttonDisabledStatus = false;
                    self.$message.error(self.$t('common.systemError'));
                })
            }
        },
        data() {
            return {
                logopath: "",
                chooseColor: '',
                activeNames: "1",
                label: {},
                test11: "1方法",
                companyInfo: {},
                buttonDisabledStatus: true,
                loading: true,
                designLoaded: false,
                loadError: '',
                predefineColors: [
                    'rgb(255,94,139)',
                    'rgb(255,124,158)',
                    'rgb(254,118,200)',
                    'rgb(148,0,211)',
                    'rgb(145,113,237)',
                    'rgb(115,128,248)',
                    'rgb(13,125,247)',
                    'rgb(56,174,233)',
                    'rgb(30,195,146)',
                    'rgb(43,181,104)',
                    'rgb(67,189,54)',
                    'rgb(105,202,25)',
                    'rgb(227,171,19)',
                    'rgb(255,144,89)',
                    'rgb(253,113,109)',
                    'rgb(253,84,79)',
                    'rgb(49,54,5)'
                ],
                predefinePdfStyleList: [
                    ["Classic", "white"],
                    ["Impact", "white"],
                    ["Minimal", "white"],
                    ["Elegance", "white"],
                    ["Modern", "white"],
                    ["Creative", "white"]
                ],
                choosePdfStyle: '',
                itemTableAndBalanceDueBackgroundColor: '',
                modernBackgroundColor: "",
                invoiceLabelColor: "",
                balanceDueTextColor: "",
                creativeInvoiceLabelBackgroundColor: "",
                tableData: [
                    {
                        code: 1001,
                        description: this.$t('classicPDF.previewItem1'),
                        quantity: 1,
                        rate: 1999,
                        unit: "Hour",
                        tax: "",
                        discount: "10%",
                        amount: 1799.10,
                        isNonTaxable: true
                    },
                    {
                        code: 1002,
                        description: this.$t('classicPDF.previewItem2'),
                        quantity: 2,
                        rate: 499,
                        unit: "Each",
                        tax: "17%",
                        discount: "0%",
                        amount: 998,
                        isNonTaxable: false
                    },
                    {
                        code: 1003,
                        description: this.$t('classicPDF.previewItem3'),
                        quantity: 3,
                        rate: 399,
                        unit: "Each",
                        tax: "17%",
                        discount: "0%",
                        amount: 1197,
                        isNonTaxable: false
                    },
                ],
                pageHaveChange: 0,
                initialDesignSnapshot: '',
                jobdetailShowLeft: '',
                jobdetailShowRight: '',
                otherFieldShow: ''
            }
        },
        mounted() {
            this.queryUserSetting();
        },
        beforeRouteLeave: function (to, from, next) {
            if (this.pageHaveChange === 1) {
                next(false);
                this.$confirm(this.$t('common.unsavedChangesMsg'), this.$t('common.saveChangesTitle'), {
                    confirmButtonText: this.$t('common.confirmSave'),
                    cancelButtonText: this.$t('common.discard'),
                    distinguishCancelAndClose: true,
                    type: 'warning'
                }).then(() => {
                    // 选择确定
                    this.saveDesign(100, next);
                }).catch(function (action) {
                    if (action === 'cancel') {
                        next();
                    }
                });
            } else {
                next();
            }
        }
    }
</script>
<style scoped>
    .invoice-design-initial-loading {
        min-height: 320px;
    }

    .invoice-design-page,
    .invoice-design-layout {
        height: 100%;
        min-width: 0;
    }

    .invoice-design-layout {
        display: flex;
    }

    @font-face {
        font-family: 'OpenSans';
        src: url('../../static/font/RobotoCondensed-Regular.ttf');
    }

    /deep/ .el-card__body {
        padding-left: 20px;
        padding-top: 2px;
    }

    /deep/ .aaaa .el-input__inner {
        width: 90%;
        margin-left: 2%;
        border-style: none none solid none;
        background-color: #ffffff;
        border-radius: 0px;
        line-height: 0px;
        height: 25px;
        font-size: 17px;
    }

    /deep/ .el-form--label-top .el-form-item__label {
        padding: 0px;
        padding-left: 20px;
        line-height: 0px;
        font-size: 12px;
    }

    /deep/ .aaaa .el-form-item__content {
        line-height: 0px;
    }

    /deep/ .el-collapse-item__header {
        padding-left: 20px;
        font-size: 16px;
    }

    .next-number-title {
        margin: 8px 0 12px 20px;
        color: #606266;
        font-size: var(--responsive-font-14);
        font-weight: 600;
    }

    /deep/ .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
        font-size: 20px;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 7px;
        padding-bottom: 7px;
        margin-top: 25px;
        margin-bottom: 25px;
        margin-right: 4%;

    }

    /deep/ .el-button--success.is-disabled,
    /deep/ .el-button--success.is-disabled:hover,
    /deep/ .el-button--success.is-disabled:focus {
        background-color: #a0cfff;
        border-color: #a0cfff;
        cursor: not-allowed;
    }

    .el-scrollbar {
        border-top-style: none;
        border-right-style: solid;
        border-right-width: 2px;
        border-right-color: #ebeef4;
    }

    .invoice-design-sidebar {
        height: 100vh;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        border-right: 2px solid #ebeef4;
    }

    .invoice-design-save-bar {
        flex: 0 0 auto;
        padding-left: 20px;
        text-align: left;
        background: #ffffff;
        border-bottom: 1px solid #ebeef4;
    }

    .invoice-design-scroll {
        flex: 1 1 auto;
        min-height: 0;
    }

    .invoice-design-scroll.el-scrollbar {
        border-right: none;
    }

    .invoice-design-preview-scroll {
        flex: 1 1 auto;
        min-width: 0;
        overflow: auto;
    }

    @media (max-width: 640px) {
        .invoice-design-page {
            overflow-y: auto;
        }

        .invoice-design-layout {
            display: block;
            height: auto;
        }

        .invoice-design-sidebar {
            width: 100% !important;
            height: 62vh;
            min-height: 440px;
            border-right: 0;
            border-bottom: 2px solid #ebeef4;
        }

        .invoice-design-save-bar {
            padding: 0 72px 0 20px;
        }

        .invoice-design-options-form >>> .el-form-item {
            display: block;
        }

        .invoice-design-options-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            line-height: 24px;
        }

        .invoice-design-options-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .invoice-design-preview-scroll {
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
        }

        .invoice-design-preview-scroll .rightScrollbar {
            width: 760px !important;
            min-width: 760px;
            margin: 20px 12px 30px !important;
        }
    }
</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    @media (max-width: 1280px) {
        .leftScrollbar {
            width: 80%;
        }

        .rightScrollbar {
            margin-left: 3%;
            width: 93%;
        }

    }

    @media (min-width: 1281px) and (max-width: 1500px) {
        .leftScrollbar {
            width: 60%;
        }

        .rightScrollbar {
            margin-left: 3%;
            width: 93%;
        }
    }

    @media (min-width: 1501px) {
        .leftScrollbar {
            width: 35%;
        }

        .rightScrollbar {
            margin-left: 9%;
            width: 68%;
        }
    }
</style>
